import React from 'react';
import { motion } from 'framer-motion';
import { FiExternalLink, FiGithub, FiEye } from 'react-icons/fi';
import Badge from '../../UI/Badge';
import './ProjectCard.css';

const ProjectCard = ({ project, onView, size = "large" }) => {
  const {
    title,
    description,
    category,
    technologies,
    status,
    year,
    demoUrl,
    githubUrl,
    featured,
    icon
  } = project;

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'completed':
        return 'Concluído';
      case 'in-progress':
        return 'Em desenvolvimento';
      default:
        return 'Planejado';
    }
  };

  const getStatusVariant = (status) => {
    switch (status) {
      case 'completed':
        return 'success';
      case 'in-progress':
        return 'warning';
      default:
        return 'secondary';
    }
  };

  return (
    <motion.div
      className={`project-card ${size === 'small' ? 'project-card--small' : ''}`}
      variants={cardVariants}
      whileHover={{ y: -10 }}
      transition={{ duration: 0.3 }}
    >
      {featured && (
        <div className="project-card__badge">
          Destaque
        </div>
      )}

      <div className="project-card__image">
        {project.image ? (
          <img src={project.image} alt={title} />
        ) : (
          <div className="project-card__image-placeholder">
            {icon || '📁'}
            <span>Preview em breve</span>
          </div>
        )}
        <div className="project-card__overlay">
          <div className="project-card__actions">
            <button
              className="project-card__action"
              onClick={onView}
              title="Ver detalhes"
            >
              <FiEye />
            </button>
            {githubUrl && (
              <a
                href={githubUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="project-card__action"
                title="Ver código"
              >
                <FiGithub />
              </a>
            )}
            {demoUrl && (
              <a
                href={demoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="project-card__action"
                title="Ver Projeto"
              >
                <FiExternalLink />
              </a>
            )}
          </div>
        </div>
      </div>

      <div className="project-card__content">
        <div className="project-card__header">
          <Badge variant="primary" size="small" className="project-card__category">
            {category}
          </Badge>
          <span className="project-card__year">{year}</span>
        </div>

        <h3 className="project-card__title">{title}</h3>
        <p className="project-card__description">{description}</p>

        <div className="project-card__technologies">
          {technologies.slice(0, 3).map((tech, index) => (
            <span key={index} className="project-card__tech">
              {tech}
            </span>
          ))}
          {technologies.length > 3 && (
            <span className="project-card__tech project-card__tech--more">
              +{technologies.length - 3}
            </span>
          )}
        </div>

        <div className="project-card__status">
          <Badge
            variant={getStatusVariant(status)}
            size="small"
            className={`project-card__status-badge project-card__status-badge--${status}`}
          >
            {getStatusLabel(status)}
          </Badge>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;